var FX = (function(FX, $) {

    $( function() {
        FX.Account.init();
    });

    FX.Account = {
        init: function () {
            if (window.location.hash) {
                const target = window.location.hash;
                window.location.hash = ''; // Prevent browser from scrolling down
                if ('#register' === target) {
                    this.activeTab = 'register';
                }
            }

            $('#catalog_country').change(function () {
                const states = initialState.states[$(this).val()];
                if (undefined !== states) {
                    let stateOptions = '';
                    Object.keys(states).forEach(function (val) {
                        stateOptions += '<option value="' + val + '">' + states[val] + '</option>';
                    });
                    $('#catalog_state').html(stateOptions).trigger('change');
                }
            });
            if (undefined !== initialState.shippingAddress) {
                Object.keys(initialState.shippingAddress).forEach(function (idx) {
                    if ('state' !== idx) {
                        $('#catalog_' + idx).val(initialState.shippingAddress[idx]);
                        if ('country' === idx) {
                            $('#catalog_country').trigger('change');
                        }
                    }
                });
                $('#catalog_state').val(initialState.shippingAddress.state);
            }
        },

        activeTab: 'login',

        Login: {
            username: '',
            password: '',

            ranValidation: false,
            errors: {},

            maybeValidate: function() {
                if (this.ranValidation) {
                    this.validate();
                }
            },
            validate: function() {
                this.errors = {};
                if (this.username === '') {
                    this.errors.username = 'Please enter your username';
                }
                if (this.password === '') {
                    this.errors.password = 'Please enter your password';
                }
                this.ranValidation = true;
                return Object.keys(this.errors).length === 0;
            },
            submit: function() {
                if (this.validate()) {
                    if (typeof widgetLogin !== 'undefined') {
                        grecaptcha.reset(widgetLogin);
                        grecaptcha.execute(widgetLogin);
                    } else {
                        widgetLogin = grecaptcha.render('login-recaptcha', {
                            'sitekey' : $('#login-recaptcha').data('sitekey'),
                            'callback' : onSubmitLogin,
                            'size' : "invisible"
                        });
                        grecaptcha.execute(widgetLogin);
                    }
                }
            }
        },

        Register: {
            username: '',
            email: '',

            ranValidation: false,
            errors: {},

            usernameUpdate: function() {
                this.clearErrors('usernameUpdate');
                this.maybeValidate();
                if (this.username) {
                    const data = {
                        username: this.username
                    };
                    const options = {
                        endpoint: 'check-username',
                        data: data,
                        success: $.proxy(this.usernameUpdateResponse, this),
                    };
                    FX.AJAX.callREST(options);
                }
            },
            usernameUpdateResponse: function(response) {
                if (!response.success) {
                    response.data.forEach(function(error) {
                        this.addError('username', error, 'usernameUpdate');
                    }, this);
                }
            },
            emailUpdate: function() {
                this.clearErrors('emailUpdate');
                this.maybeValidate();
                if (this.email) {
                    const data = {
                        email: this.email
                    };
                    const options = {
                        endpoint: 'check-email',
                        data: data,
                        success: $.proxy(this.emailUpdateResponse, this),
                    };
                    FX.AJAX.callREST(options);
                }
            },
            emailUpdateResponse: function(response) {
                if (true === response.data.exists) {
                    this.addError('email', 'An account already exists with this email address. Would you like to <a href="/my-account/">login</a>?', 'emailUpdate');
                }
            },
            maybeValidate: function() {
                if (this.ranValidation) {
                    this.validate();
                }
            },
            validate: function() {
                this.clearErrors('validate');
                $('.js-vehicle-row .input-validation-error').removeClass('input-validation-error');
                if (this.username === '') {
                    this.addError('username', 'Please enter your desired username', 'validate');
                }
                if (this.email === '') {
                    this.addError('email', 'Please enter your email', 'validate');
                }

                // One day we may un-jQuery the vehicle fields...but that is not this day
                const $make = $(FX.Account.$refs.makeSelect),
                      $model = $(FX.Account.$refs.modelSelect),
                      $year = $(FX.Account.$refs.yearSelect);

                if (!$make.val()) {
                    $make.parent().addClass('input-validation-error');
                    this.addError('make', 'no make', 'validate');
                }
                if (!$model.val()) {
                    $model.parent().addClass('input-validation-error');
                    this.addError('model', 'no model', 'validate');
                }
                if (!$year.val()) {
                    $year.parent().addClass('input-validation-error');
                    this.addError('year', 'no year', 'validate');
                }
                if (!this.ranValidation) {
                    // Run validation on every select change now
                    $(FX.Account.$el).find('select').on('select2:select', $.proxy(this.validate, this));
                }

                this.ranValidation = true;
                return this.numErrors() === 0;
            },
            submit: function() {
                if (this.validate()) {
                    if (typeof widgetRegister !== 'undefined') {
                        grecaptcha.reset(widgetRegister);
                        grecaptcha.execute(widgetRegister);
                    } else {
                        widgetRegister = grecaptcha.render('register-recaptcha', {
                            'sitekey': $('#register-recaptcha').data('sitekey'),
                            'callback': onSubmitRegister,
                            'size': 'invisible'
                        });
                        grecaptcha.execute(widgetRegister);
                    }
                }
            },
            addError: function(field, msg, group) {
                if (this.errors[group] === undefined) {
                    this.errors[group] = {};
                }
                if (this.errors[group][field] === undefined) {
                    this.errors[group][field] = [];
                }
                this.errors[group][field].push(msg);
            },
            getErrors: function(field) {
                let errors = [];
                Object.keys(this.errors).forEach(function(prop) {
                    if (typeof this.errors[prop] === 'object') {
                        Object.keys(this.errors[prop]).forEach(function(childProp) {
                            if (field === childProp) {
                                this.errors[prop][childProp].forEach(function(error){
                                    errors.push(error);
                                });
                            }
                        }, this);
                    }
                }, this);
                if (errors) {
                    return errors.join('<br>');
                }
                return false;
            },
            numErrors: function() {
                let num = 0;
                Object.keys(this.errors).forEach(function(prop) {
                    if (typeof this.errors[prop] === 'object') {
                        Object.keys(this.errors[prop]).forEach(function(childProp) {
                            this.errors[prop][childProp].forEach(function(error){
                                num++;
                            });
                        }, this);
                    }
                }, this);
                return num;
            },
            clearErrors: function(type) {
                this.errors[type] = {};
            },
        },
    };

    FX.Reviews = {
        ProductRow: function() {
            return {
                review: {},
                partID: '',
                openReview: false,
                hasReview: false,
                hoverRating: 0,
                tempRating: 0,
                tempText: '',
                isLoading: false,
                msgSuccess: '',
                msgError: '',

                init: function(partID) {
                    this.partID = partID;
                    this.review = initialState.reviews[ partID ];
                    this.hasReview = this.review.text.length > 0;
                    if (this.hasReview) {
                        this.tempRating = this.review.rating;
                        this.tempText = this.review.text;
                    }
                },

                fillStar: function(i) {
                    if (!this.openReview) {
                        return this.review.rating >= i;
                    } else if ( 0 === this.hoverRating) {
                        return this.tempRating >= i;
                    }
                    return this.hoverRating >= i;
                },

                addReview: function() {
                    this.clearMessages();
                    if ( this.tempRating === this.review.rating && this.tempText === this.review.text ) {
                        // If no changes were made, just close and return
                        this.openReview = false;
                        return;
                    }
                    const data = {
                        part_id: this.partID,
                        rating: this.tempRating,
                        text: this.tempText,
                    };
                    const options = {
                        endpoint: 'product-review',
                        data: data,
                        success: this.reviewResponse.bind(this),
                    };
                    if (this.hasReview) {
                        options.method = 'PUT';
                    }
                    this.isLoading = true;
                    FX.AJAX.callREST(options);
                },

                reviewResponse: function(response) {
                    this.isLoading = false;
                    if (response.success) {
                        this.msgSuccess = response.data;
                        this.review.rating = this.tempRating;
                        this.review.text = this.tempText;
                        this.review.status = 'pending';
                        this.hasReview = true;
                        this.openReview = false;
                    } else {
                        this.msgError = response.data;
                    }
                },

                deleteReview: function() {
                    if ( ! window.confirm( 'Are you sure you want to delete this review?' ) ) {
                        return;
                    }
                    this.clearMessages();
                    const data = {
                        part_id: this.partID,
                    };
                    const options = {
                        endpoint: 'product-review',
                        data: data,
                        method: 'DELETE',
                        success: this.deleteResponse.bind(this),
                    };
                    this.isLoading = true;
                    FX.AJAX.callREST(options);
                },

                deleteResponse: function(response) {
                    this.isLoading = false;
                    if (response.success) {
                        this.msgSuccess = response.data;
                        this.openReview = false;
                        this.review.rating = '';
                        this.review.text = '';
                        this.review.status = '';
                        this.tempRating = 0;
                        this.tempText = '';
                        this.hasReview = false;
                    } else {
                        this.msgError = response.data;
                    }
                },

                cancel: function() {
                    this.clearMessages();
                    this.openReview = false;
                    this.tempRating = this.review.rating ? this.review.rating : 0;
                    this.tempText = this.review.text ? this.review.text : '';
                },

                clearMessages: function() {
                    this.msgError = '';
                    this.msgSuccess = '';
                }
            };
        },
    };
    return FX;
}(FX || {}, jQuery));

function onSubmitLogin(token) {
    if (token) {
        FX.Account.$refs.loginForm.submit();
    } else {
        FX.Account.Login.errors.recaptchaToken = true;
    }
}

function onSubmitRegister(token) {
    if (token) {
        FX.Account.$refs.registerForm.submit();
    } else {
        FX.Account.Register.errors.recaptchaToken = true;
    }
}
